import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { path } from '../endpoints';

import { CirclePackWrapper } from './wrapper';
import { CirclePackKnobs } from './knobs';
import { filterProperties } from 'utilities/srsUtils';

const flags = [SrsPropertyFlag.Hierarchical];

export const config = {
	key: 'CIRCLE_PACK',
	label: 'Circle Pack',
	icon: 'circle-pack',
	wrapper: CirclePackWrapper,
	endpoint: path,
	Knobs: CirclePackKnobs,
	flags: flags,
	createDefaultOptions: filteredProperties => {
		return {
			options: {
				propertyList: [filteredProperties[0].name],
				parameters: {
					MaxChildren: null,
					pathDepth: 3,
					parentPath: [],
					pathDelimiter: '/',
				},
			},
		};
	},
	createDefaultConfiguration: _filteredProperties => {
		return {
			showAllLabels: false,
		};
	},
	isValid: selectedDefinitionName => {
		return filterProperties(selectedDefinitionName, flags).length >= 1;
	},
};
